<!-- ============================================================== -->
<!-- Preloader - style you can find in spinners.css -->
<div class="preloader">
  <div class="lds-ripple">
    <div class="lds-pos"></div>
    <div class="lds-pos"></div>
  </div>
</div>
<!-- ============================================================== -->
<div class="page-breadcrumb">
  <div class="row d-flex justify-content-between">
    <div class="align-self-center ">
      <h3 class="page-title text-truncate text-dark font-weight-medium m-3 ml-4">Exam Management -
        {{ Exam?.subject_code }} {{ Exam?.subject_name }}
      </h3>
      <div class="d-flex align-items-center">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb m-0 p-0">
            <li class="breadcrumb-item"><a></a>
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="align-self-center">
      <a data-toggle="modal" data-target="#create-division-modal"
        class="ml-2 d-sm-inline text-white btn btn-sm btn-primary shadow-sm"><i
          class="fa fa-plus fa-sm text-white-50"></i>
        Add Division </a>
      <a data-toggle="modal" *ngIf="!isPortal" (click)="show_question_or_portal()"
        class="ml-2 d-sm-inline text-white btn btn-sm btn-primary shadow-sm"><i
          class="fa fa-plus fa-sm text-white-50"></i>
        Show Mark's Portal </a>
      <a data-toggle="modal" *ngIf="isPortal" (click)="show_question_or_portal()"
        class="ml-2 d-sm-inline text-white btn btn-sm btn-primary shadow-sm"><i
          class="fa fa-plus fa-sm text-white-50"></i>
        Show Question Pattern </a>

    </div>
  </div>
</div>

<div *ngIf="!isPortal">
  <div class="page-breadcrumb pt-5 container pb-5 mb-5" *ngFor="let division of Exam['divisions']">
    <hr>
    <div class="row d-flex justify-content-between">
      <div class="align-self-center ">
        <h3 class="page-title text-truncate text-dark font-weight-medium m-3 ml-4">{{division.division_name}}
        </h3>
      </div>
      <div class="align-self-center">
        {{division.no_of_questions_to_attend}} X {{division.mark_per_question}} = {{division.division_mark}}
        <!-- <a data-toggle="modal" data-target="#create-question-modal" (click)="set_division(division)"
          class="ml-2 float-right mx-5 text-white btn btn-sm btn-primary shadow-sm"><i
            class="fa fa-plus fa-sm text-white-50"></i>
          Add Question </a> -->
      </div>
    </div>
    <hr>
    <div class="container d-flex justify-content-between" *ngFor="let question of division['questions']">
      <div>
        {{question.question_number}}. {{question.question}}
      </div>
      <div *ngIf="question.course_o_name">
        {{question.course_o_name}}
        <i (click)="pop_edit_question(question)" class="fas fa-edit"></i>
      </div>
      <div *ngIf="!question.course_o_name">
        No CO Mapped
        <i (click)="pop_edit_question(question)" class="fas fa-edit"></i>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isPortal">
  <table class="table table-hover table-striped container" *ngIf="Responses">
    <thead>
      <tr>
        <th>Student \ Particulars</th>
        <th>Marks</th>
        <!-- <th colspan="{{division['questions'].length}}" *ngFor="let division of Exam['divisions']">
          {{division.division_name}}
        </th> -->
      </tr>
      <!-- <tr>
        <span *ngFor="let division of Exam['divisions']">
          <td *ngFor="let question of division['questions']"> {{question.question_number}}
          </td>
        </span>
      </tr> -->
    </thead>


    <tbody>
      <tr *ngFor="let student of Students">
        <th>{{student.register_number}} - {{student.username}}</th>
        <span *ngFor="let division of Exam['divisions']">
          <th *ngFor="let question of division['questions']">

            <span *ngFor="let value of Responses.responses"> <input
                *ngIf="question.question_id == value.question_id && student.student_id == value.student_id"
                (input)="update_value(value)" [(ngModel)]=value.question_mark>
            </span>
          </th>

        </span>
      </tr>
    </tbody>

  </table>
</div>

<h3 class="page-title text-truncate text-dark font-weight-medium mx-2 my-4">Results
</h3>
<div *ngIf="isPortal">
  <table class="table table-hover table-striped" *ngIf="Responses">
    <thead>
      <tr>
        <th>Student \ Particulars</th>
        <th *ngFor="let co of Responses.cos">{{co.co_name}}</th>
        <th>Total Mark</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let student of Responses.students">
        <th>{{student.student_name}}</th>
        <th *ngFor="let value of student['values']">
          {{value.co_mark}}
          <!-- <span *ngFor="let value of Responses.responses"> <input
            *ngIf="question.question_id == value.question_id && student.student_id == value.student_id"
            (input)="update_value(value)" [(ngModel)]=value.question_mark>
          </span> -->

        </th>
        <th>{{student.student_mark}}</th>
      </tr>

    </tbody>

  </table>
</div>



<!-- Division Modal modal content -->
<div id="create-division-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <form #formValues4="ngForm" (ngSubmit)="create_factor(formValues4)" class="pl-3 pr-3">

          <!-- Division name - division_name - text - required -->
          <div class="form-group">
            <label>Division name</label>
            <input class="form-control" [(ngModel)]="Division.division_name" name="division_name"
              #division_name="ngModel" type="text" placeholder="Enter Division name" required>
            <div class="error" *ngIf="division_name.touched && !division_name.valid"> Division name is
              required</div>
          </div>
          <!-- End of Division name -->

          <!-- No. of Questions - no_of_questions - text - required -->
          <div class="form-group">
            <label>No. of Questions</label>
            <input class="form-control" [(ngModel)]="Division.no_of_questions" name="no_of_questions"
              #no_of_questions="ngModel" type="text" placeholder="Enter No. of Questions" required>
            <div class="error" *ngIf="no_of_questions.touched && !no_of_questions.valid"> Division
              name is
              required</div>
          </div>
          <!-- End of No. of Questions -->

          <!-- No. of Questions to Attend - no_of_questions_to_attend - text - required -->
          <div class="form-group">
            <label>No. of Questions to Attend</label>
            <input class="form-control" [(ngModel)]="Division.no_of_questions_to_attend"
              name="no_of_questions_to_attend" #no_of_questions_to_attend="ngModel" type="text"
              placeholder="Enter No. of Questions to Attend" required>
            <div class="error" *ngIf="no_of_questions_to_attend.touched && !no_of_questions_to_attend.valid">
              Division
              name is
              required</div>
          </div>
          <!-- End of No. of Questions to Attend -->

          <!-- Mark per Question - mark_per_question - text - required -->
          <div class="form-group">
            <label>Mark per Question</label>
            <input class="form-control" [(ngModel)]="Division.mark_per_question" name="mark_per_question"
              #mark_per_question="ngModel" type="text" placeholder="Enter Mark per Question" required>
            <div class="error" *ngIf="mark_per_question.touched && !mark_per_question.valid">
              Division
              name is
              required</div>
          </div>
          <!-- End of Mark per Question -->

          <!-- Course Outcome - form - [ course_o_name - course_o_id ] - ng-select - selectedIndustry -->
          <!-- <div class="form-group">
            <label>Course Outcome</label>
            <ng-select [items]="COutcomes[0]['attainments']" bindLabel="course_o_name" autofocus bindValue="course_o_id"
              [(ngModel)]="Division.course_o" name="course_o" placeholder="Select Course Outcome">
            </ng-select>
          </div> -->
          <!-- End of Select Course Outcome -->

          <div class="form-group text-center">
            <button class="btn btn-primary" type="submit">Create Division</button>
          </div>


        </form>
      </div>
    </div>
  </div>
</div>
<!-- End of Coutcome Modal -->



<!-- Question Modal modal content -->
<div id="question-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">

        <!-- ===================================================================================== -->

        <form *ngIf="!isEdit" #formValues1="ngForm" (ngSubmit)="create_question(formValues1)" class="pl-3 pr-3">
          <!-- Question - question - text - required -->
          <div class="form-group">
            <label>Question</label>
            <input class="form-control" [(ngModel)]="Question.question" name="question" #question="ngModel" type="text"
              placeholder="Enter Question" required>
            <div class="error" *ngIf="question.touched && !question.valid"> Question is
              required</div>
          </div>
          <!-- End of Question -->

          <!-- Course Outcome - form - [ course_o_name - course_o_id ] - ng-select - selectedIndustry -->
          <div class="form-group">
            <label>Course Outcome</label>
            <ng-select [items]="COutcomes['attainments']" bindLabel="course_o_name" autofocus bindValue="course_o_id"
              [(ngModel)]="Question.co_value" name="co_value" placeholder="Select Course Outcome">
            </ng-select>
          </div>
          <!-- End of Select Course Outcome -->

          <div class="form-group text-center">
            <button class="btn btn-primary" type="submit">Create Question</button>
          </div>
        </form>

        <!-- ===================================================================================== -->
        <!-- ===================================================================================== -->

        <form *ngIf="isEdit" #formValues2="ngForm" (ngSubmit)="edit_question(formValues2)" class="pl-3 pr-3">

          <!-- Question - question - text - required -->
          <div class="form-group">
            <label>Question</label>
            <input class="form-control" [(ngModel)]="Question.question" name="question" #question="ngModel" type="text"
              placeholder="Enter Question" required>
            <div class="error" *ngIf="question.touched && !question.valid"> Question is
              required</div>
          </div>
          <!-- End of Question -->

          <!-- Course Outcome - form - [ course_o_name - course_o_id ] - ng-select - selectedIndustry -->
          <div class="form-group">
            <label>Course Outcome</label>
            <ng-select [items]="COutcomes['attainments']" bindLabel="course_o_name" autofocus bindValue="course_o_id"
              [(ngModel)]="Question.co_value" name="co_value" placeholder="Select Course Outcome">
            </ng-select>
          </div>
          <!-- End of Select Course Outcome -->

          <div class="form-group text-center">
            <button class="btn btn-primary" type="submit">Update Question</button>
          </div>
        </form>

        <!-- ===================================================================================== -->

      </div>
    </div>
  </div>
</div>
<!-- End of Coutcome Modal -->
